/**
 * The survey URL is where respondents are sent. `[ID]` in it becomes the respondent's GUID; without `[ID]` the server
 * appends `rid=<GUID>`. The server accepts http(s) only (400 with `errors` otherwise), so the form checks that first.
 */
export const SURVEY_URL_EXAMPLE = 'https://survey.example.com/s/123?rid=[ID]';
export const SURVEY_URL_HINT = 'Where respondents are sent. [ID] becomes the respondent\'s ID; without it, rid=<ID> is added at the end.';

/** '' when the value is empty (the URL is optional) or a valid http(s) URL; otherwise the message to show. */
export function surveyUrlError(value: string): string {
  const text = value.trim();
  if (!text) return '';
  try {
    const url = new URL(text.replace('[ID]', 'ID')); // "[" and "]" are fine for the server but not for URL(), so test with a stand-in
    return url.protocol === 'http:' || url.protocol === 'https:' ? '' : 'The survey URL must start with http:// or https://';
  } catch (e) {
    return 'Enter a full survey URL, for example ' + SURVEY_URL_EXAMPLE;
  }
}
